import script from "./BoardTypeManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./BoardTypeManagement.vue?vue&type=script&setup=true&lang=js"

import "./BoardTypeManagement.vue?vue&type=style&index=0&id=88ba778c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88ba778c"]])

export default __exports__